import React, { useState, useCallback } from 'react';
import './App.css';
import MaterialTypeGrid from './components/MaterialTypeGrid';
import MaterialList from './components/MaterialList';
import Toolbar from './components/Toolbar';
import { materialTypes } from './data/materials';

import BackToTop from './components/mobile/BackToTop';

function App() {
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [quantities, setQuantities] = useState({});

  const handleMaterialSelect = useCallback((material) => {
    setSelectedMaterial(material);
  }, []);

  const handleQuantityChange = useCallback((materialType, material, value) => {
    setQuantities(prev => ({
      ...prev,
      [materialType]: {
        ...prev[materialType],
        [material]: value
      }
    }));
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <h1 className="app-title">
            <span className="title-icon">🌱</span>
            Carbon Footprint Calculator
          </h1>
          <p className="app-subtitle">
            Calculate the environmental impact of your waste materials
          </p>
        </div>
      </header>
      
      
      <main className="App-main">
        <div className="main-container">
          <div className="content-grid">
            
          <div className="grid-section">
              <MaterialTypeGrid
                materialTypes={materialTypes}
                selectedMaterial={selectedMaterial}
                onMaterialSelect={handleMaterialSelect}
              />
            </div>

            <div className="list-section">
              <MaterialList 
                selectedMaterial={selectedMaterial}
                quantities={quantities}
                onQuantityChange={handleQuantityChange}
              />
            </div>
            

          </div>

          <Toolbar quantities={quantities} />
          <BackToTop />
        </div>
      </main>
    </div>
  );
}

export default App;
